export const BOARD_SETTINGS_CREATE_CARD_COLOR_MODAL_ID =
	'BOARD_SETTINGS_CREATE_CARD_COLOR_MODAL_ID';
export const BOARD_SETTINGS_EDIT_CARD_COLOR_MODAL_ID = 'BOARD_SETTINGS_EDIT_CARD_COLOR_MODAL_ID';
